import { render } from "./BaseCheckbox.vue?vue&type=template&id=5b44d53a"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Inputs/BaseCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b44d53a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b44d53a', __exports__)) {
    api.reload('5b44d53a', __exports__)
  }
  
  module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=5b44d53a", () => {
    api.rerender('5b44d53a', render)
  })

}


export default __exports__